export default __webpack_public_path__ + "static/media/hero-avatar-2.0045a1d1.jpg";